import { WidgetSize, WidgetType } from 'components/farm-dashboard/types'
import { LicensesType } from 'models/IUserData'
export const HEALTH_TABLE_WIDGETS = [
	{
		id: WidgetType.LAMENESS_LINE_CHART,
		type: WidgetType.LAMENESS_LINE_CHART,
		size: WidgetSize.LARGE,
		license: LicensesType.LAMENESS,
	},
	{
		id: WidgetType.LAME_HEADS,
		type: WidgetType.LAME_HEADS,
		size: WidgetSize.SMALL,
		license: LicensesType.LAMENESS,
	},
	{
		id: WidgetType.DISPOSE_RECOMMENDED,
		type: WidgetType.DISPOSE_RECOMMENDED,
		size: WidgetSize.SMALL,
		license: LicensesType.LAMENESS,
	},
	{
		id: WidgetType.FATNESS_DONUT_CHART,
		type: WidgetType.FATNESS_DONUT_CHART,
		size: WidgetSize.LARGE,
		license: LicensesType.FATNESS,
	},

	{
		id: WidgetType.CRIT_FATNESS_HEAD,
		type: WidgetType.CRIT_FATNESS_HEAD,
		size: WidgetSize.SMALL,
		license: LicensesType.LAMENESS,
	},
]
